import { useTranslation } from "react-i18next";
import layoutStyles from "../layout/SectionLayout.module.css";

/**
 * The My Groups "hide empty groups" switch, a button in the page's control group. Pressed means empty
 * groups are hidden: entitlement groups with no direct members, and groups with nobody in them.
 *
 * @param props.pressed - Whether empty groups are currently hidden.
 * @param props.onChange - Called with the new setting.
 */
export function HideEmptyGroupsToggle({ pressed, onChange }: { pressed: boolean; onChange: (hide: boolean) => void }): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <button type="button" className={layoutStyles.option} aria-pressed={pressed} onClick={() => onChange(!pressed)}>
      <svg className={layoutStyles.icon} viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <path d="M2 3h12l-4.5 5.5V13l-3-1.5V8.5z" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
      </svg>
      <span>{t("myGroups.hideEmpty")}</span>
    </button>
  );
}
